import { render, staticRenderFns } from "./IconBellSolid.vue?vue&type=template&id=30d3d003"
import script from "./IconBellSolid.vue?vue&type=script&lang=js"
export * from "./IconBellSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports